module.exports = __webpack_public_path__ + "static/img/zx.67930787.png";